// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"710f69f8","232":"8c325ce3","485":"454bc138","894":"4237e82e"}[chunkId] + ".css";
};